import { FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material'
import { connectField } from 'dynamic-uniforms'
import { useCiboAutoForm } from './CiboAutoFormContext'
import { ClearButton } from './ClearButton'
import { FieldLabel } from './FieldLabel'
import { ValidationMessages } from './ValidationMessages'

type BooleanRadioInputProps = {
  name: string
  value?: boolean
  label?: string
  onChange: (value: boolean | undefined) => void
  disabled?: boolean
  required?: boolean
  error?: { message: string }
  [key: string]: any
}

export function BooleanRadioInput(props: BooleanRadioInputProps) {
  const { name, value, label, onChange, disabled, required } = props
  const { touch } = useCiboAutoForm()
  const canClear = !disabled && value !== undefined

  return (
    <FormControl fullWidth required={required} disabled={disabled}>
      {label && <FieldLabel label={label} required={required} />}
      <Stack direction="row" alignItems="center">
        <RadioGroup
          row
          name={name}
          value={value === undefined ? '' : value ? 'true' : 'false'}
          onChange={e => {
            const val = e.target.value
            if (val === 'true') onChange(true)
            else if (val === 'false') onChange(false)

            touch(name)
          }}
          onBlur={() => touch(name)}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={disabled} />
          <FormControlLabel value="false" control={<Radio />} label="No" disabled={disabled} />
        </RadioGroup>

        {canClear && (
          <ClearButton
            tooltipKey="clearButton.selection"
            onClick={() => onChange(undefined)}
            sx={{ marginLeft: 1 }}
          />
        )}
      </Stack>
      <ValidationMessages
        fieldName={props.name}
        error={props.error as { message: string } | undefined}
      />
    </FormControl>
  )
}

export default connectField(BooleanRadioInput)
